<template>
    <div :key="key+321">
        <card shadow :class="['bg-secondary','shadow','border-'+cardStyle,isLoading ? 'loading-card' : '']"   shadow-size="5" :header-classes="'bg-'+cardStyle">
            <div slot="header" v-bind:class="'bg-'+cardStyle" class="border-0">
                <div class="row align-items-center">
                    <div class="col-3">
                        <h3 class="mb-0" :class="[status.type !== '' ? 'text-white' : '']">Check</h3>
                        <h6 class="text-uppercase text-danger ls-1 mb-0">{{ (isDemo()) ? 'DEMO' : 'OASIS wurde noch nicht konfiguriert - KEINE OASIS SPERRABFRAGE'}}</h6>
                    </div>
                  <div :key="key+'btn451'" class="col-9 text-right">
                    <base-button v-if="reset"
                                 @click="setDefaultData"
                                 type="secondary" icon="fas fa-undo-alt" alt="zurück"></base-button>
                    <base-button disabled type="secondary" v-on:click="addOrEditPlayer" icon="fas fa-ban" alt="Spieler sperren"></base-button>
                    <base-button  v-on:click="checkPlayer" icon="fas fa-search" alt="Spieler prüfen"></base-button>
                  </div>
                </div>
            </div>
            <base-alert v-if="!isDemo()" type="danger">
                <span class="text-white">Um OASIS zu konfigurieren, müssen Sie sich zunächst mit Ihrem Admin-Zugang einloggen. Folgen Sie anschließend den Anweisungen in der Anleitung. <a href="https://service.socialguard.app/kb/faq.php?id=11" target="_blank">Zur Anleitung</a></span>
            </base-alert>
            <base-alert v-if="status.type !== '' && !status.showBlockedInfo" :type="status.type" autofocus>{{ status.message }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Spieler information</h6>
                    <div class="row">
                        <div v-if="status.showBlockedInfo" class="col-lg-4 order-md-last text-center">
                            <h1 v-if="playerBlocked" class="text-danger display-1">:(</h1>
                            <h1 v-else class="text-success display-1">:)</h1>
                            <base-alert :type="cardStyle">
                                <span class="text-white"> {{ status.message }} </span>
                            </base-alert>
                        </div>
                        <div class="col-lg-8">
                        <form @submit.prevent="checkPlayer">
                            <!--- Pass ID ist nicht stabil, da sich die ID bei einem neuen Ausweis ändert
                        <div class="row align-items-center ausweis">
                            <div class="col-lg-8">
                                <base-input alternative=""
                                            label="Ausweis ID"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Ausweis ID hier eingeben"
                                            input-classes="form-control-alternative form-control-lg"
                                            v-model="model.passportid"
                                />
                                <a v-if="(!detailSearch && !addPlayerForm)" href="" @click.prevent="detailSearch = !detailSearch">Detailsuche einblenden</a>
                            </div>
                        </div>--->
                            <div class="row">
                            <input type="hidden" id="nationality">
                              <div class="col-lg-6">
                              <base-input alternative=""
                                          v-bind:readonly="isLoading"
                                          label="Vorname"
                                          class="col-form-label col-form-label-lg mb-0"
                                          placeholder="Vorname hier eingeben"
                                          :input-classes="['form-control-alternative','form-control-lg',errors.includes('V') ? 'is-invalid' : '']"
                                          v-model.trim="model.firstname"
                              /></div>
                              <div class="col-lg-6">
                                <base-input alternative=""
                                        v-bind:readonly="isLoading"
                                        label="Nachname"
                                        class="col-form-label col-form-label-lg mb-0"
                                        placeholder="Nachname hier eingeben"
                                        :input-classes="['form-control-alternative','form-control-lg',errors.includes('N') ? 'is-invalid' : '']"
                                        v-model.trim="model.lastname"
                                /></div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                <base-input
                                        label="Geburtstag"
                                        required
                                        class="col-form-label col-form-label-lg"
                                        placeholder="Geburtsdatum hier eingeben"
                                >
                                    <flat-pickr :key="key" slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 ref="pickr"
                                                 :config="config"
                                                 :class="['form-control','form-control-alternative','form-control-lg','datepicker', errors.includes('bornAt') ? 'is-invalid' : '']"
                                                 v-model="model.bornAt">
                                    </flat-pickr>
                                </base-input>
                                  <input type="hidden" id="birthday" v-on:blur="updateOnBlur" v-model="model.bornAt">
                                </div>
                                </div>
                        <div v-if="!addPlayerForm" class="row align-items-center" style="height: 100%;">
                            <div class="col-lg-8">
                                <button name="checkplayer" class="btn btn-icon my-4 btn-primary" :disabled="isLoading" type="submit">
                                    <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="fas fa-search"></i></span>
                                    <span class="btn-inner--text">Spieler prüfen</span></button>
                                <base-button disabled type="secondary" v-on:click="addOrEditPlayer">Sperren</base-button>
                            </div>
                        </div>
                        </form>
                        </div>
                    </div>
                    <hr v-if="addPlayerForm" class="my-4"/>
                    <!-- Address -->
                    <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Ergänzende Spieler Informationen</h6>
                    <div v-if="addPlayerForm" class="pl-lg-4">
                        <div class="row">
                            Bitte prüfen Sie die folgenden Angaben auf Vollständig- und Korrektheit. Sollten Werte nicht oder falsch angegeben worden sein, korrigieren Sie diese bitte.
                        </div>
                        <div class="row">
                            <div class="col-lg-2">
                                <base-radio class="col-form-label col-form-label-lg mb-3"
                                            input-classes="form-control-alternative form-control-lg"
                                            name="Herr"
                                            v-model="model.title">
                                    Herr
                                </base-radio>
                            </div>
                            <div class="col-lg-2">
                                <base-radio class="col-form-label col-form-label-lg mb-3"
                                            input-classes="form-control-alternative form-control-lg"
                                            name="Frau"
                                            v-model="model.title">
                                    Frau
                                </base-radio>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <base-input alternative=""
                                            label="Postleitzahl"
                                            type="number"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Postleitzahl hier eingeben"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('postcode') ? 'is-invalid' : '']"
                                            v-model="model.postcode"
                                /></div>
                            <div class="col-lg-4">
                                <base-input alternative=""
                                            label="Wohnort"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Wohnort hier eingeben"
                                            :input-classes="['form-control-alternative','form-control-lg',errors.includes('city') ? 'is-invalid' : '']"
                                            v-model="model.city"
                                /></div>
                        </div>
                        <div class="row">
                        <div class="col-lg-4">
                            <base-input alternative=""
                                        label="Straße und Hausnummer"
                                        class="col-form-label col-form-label-lg"
                                        placeholder="Straße und Hausnr hier eingeben"
                                        :input-classes="['form-control-alternative','form-control-lg',errors.includes('streetandnr') ? 'is-invalid' : '']"
                                        v-model="model.streetandnr"
                            /></div>
                        <div class="col-lg-4">
                            <base-input alternative=""
                                        label="Nationalität"
                                        class="col-form-label col-form-label-lg"
                                        placeholder="Nationalität hier eingeben"
                                        :input-classes="['form-control-alternative','form-control-lg',errors.includes('nationality') ? 'is-invalid' : '']"
                                        v-model="model.nationality"
                            /></div>
                    </div>
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Einstellungen für Benachrichtigung</h6>
                        <div class="row">
                            <div class="col-lg-8">
                            Sofern der Spieler eine Bestätigung über seine Sperrung erhalten möchte, bitte hier eine E-Mail Adresse eingeben.
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-8">
                                <!-- :input-classes="[(isEmailValid === null) ? 'form-control-alternative' : '','form-control-lg']" -->
                                <label class="form-control-label">
                                    E-Mail
                                    </label>
                                <base-input alternative
                                            input-classes="form-control-alternative form-control-lg"
                                            placeholder="E-Mail Adresse hier eingeben"
                                            :valid="isEmailValid"
                                            v-model="model.email"
                                /></div>
                        </div>
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Informationen zur Sperrdauer und Grund</h6>
                        <div v-if="addPlayerForm" class="pl-lg-4">
                            <div class="row">
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                :class="[errors.includes('type') ? 'is-invalid-select' : '']"
                                                name="SELBST"
                                                v-model="playerLock.type">
                                        Selbstsperre
                                    </base-radio>
                                </div>
                                <div class="col-lg-2">
                                    <base-radio class="col-form-label col-form-label-lg mb-3"
                                                :class="[errors.includes('type') ? 'is-invalid-select' : '']"
                                                name="FREMD"
                                                v-model="playerLock.type">
                                        Fremdsperre
                                    </base-radio>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4">
                                    <base-input
                                            label="Spielersperre beginnt am"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Ab wann möchte sich der Spieler sperren lassen?"
                                    >
                                        <flat-pickr slot-scope="{focus, blur}"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    :config="configDuration"
                                                    class="form-control form-control-alternative form-control-lg datepicker"
                                                    v-model="playerLock.startsAt">
                                        </flat-pickr>
                                    </base-input>
                                </div>
                                <div class="col-lg-4">
                                    <base-input
                                            label="Spielersperre endet am"
                                            class="col-form-label col-form-label-lg"
                                            placeholder="Bis wann möchte sich der Spieler sperren lassen?"
                                    >
                                        <flat-pickr slot-scope="{focus, blur}"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    :config="configDuration"
                                                    class="form-control form-control-alternative form-control-lg datepicker"
                                                    v-model="playerLock.endsAt">
                                        </flat-pickr>
                                    </base-input>
                                </div>
                            </div>
                            <div class="pl-lg-4">
                                    <div class="col-lg-2">
                                        <base-radio vale="Spielsuchtgefährdung"
                                                    class="col-form-label col-form-label-lg mb-3"
                                                    :class="[errors.includes('type') ? 'is-invalid-select' : '']"
                                                    name="Spielsuchtgefährdung"
                                                    :input-classes="['form-control-alternative','form-control-lg',errors.includes('reason') ? 'is-invalid' : '']"
                                                    v-model="playerLock.reason">
                                            Spielsuchtgefährdung
                                        </base-radio>
                                        <base-radio value="Überschuldung"
                                                    class="col-form-label col-form-label-lg mb-3"
                                                    :class="[errors.includes('type') ? 'is-invalid-select' : '']"
                                                    :input-classes="['form-control-alternative','form-control-lg',errors.includes('reason') ? 'is-invalid' : '']"
                                                    name="Überschuldung" v-model="playerLock.reason">
                                            Finanzielle Gründe (z.B. Überschuldung)
                                        </base-radio>
                                        <base-radio value="Hausverbot"
                                                    class="col-form-label col-form-label-lg mb-3"
                                                    :class="[errors.includes('type') ? 'is-invalid-select' : '']"
                                                    :input-classes="['form-control-alternative','form-control-lg',errors.includes('reason') ? 'is-invalid' : '']"
                                                    name="Hausverbot" v-model="playerLock.reason">
                                            Hausverbot
                                        </base-radio>
                                    </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <base-input alternative=""
                                                    label="Kommentar">
                                            <textarea v-model="playerLock.comment" rows="4" class="form-control form-control-alternative" placeholder="Hier kann bei Bedarf eine Erklärung oder Kommentar hinterlegt werden."></textarea>
                                        </base-input>
                                    </div>
                                </div>
                            </div>
                            </div>
                        <hr v-if="addPlayerForm" class="my-4"/>
                        <!-- Address -->
                        <h6 v-if="addPlayerForm" class="heading-small text-muted mb-4">Rechtliches</h6>
                        <div class="row">
                            <div class="col-lg-10">
                                <base-alert :type="errors.includes('PRIVACY') ? 'warning' : 'secondary'" class="border-primary">
                                    <label class="form-control-label">
                                        Datenschutz
                                    </label>
                                    <br>
                                    <switches v-model="info.dataprivacy"
                                              theme="bootstrap"
                                              color="primary"
                                              style="padding-left: 2rem;"></switches>
                                    Mit  diesem  Antrag  willige  ich, {{ model.firstname }} {{ model.lastname }}  ausdrücklich  in  die  Erhebung,  Speicherung  und  Verarbeitung meiner  personenbezogenen  Daten  (Nachname,  Geburtsname,  Vorname/n,  Geburtsdatum, Geburtsort,  Anschrift)  zur  Durchsetzung  der  Spielersperre mittels  des  Spielersperrsystems Socialguard ein.
                                </base-alert>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-10">
                                <base-alert :type="errors.includes('APPROVE') ? 'warning' : 'secondary'" class="border-danger">
                                    <label class="form-control-label">
                                        Nachweise
                                    </label>
                                    <br>
                                    <switches v-model="info.approve"
                                              theme="bootstrap"
                                              color="primary"
                                              style="padding-left: 2rem;"></switches>
                                    Der Sperrantrag, sowie ein gültiger Identitätsnachweis (z.B. Ausweis oder Führerschein) liegen schriftlich vor und werden für eventuelle Rückfragen sicher verwahrt.
                                </base-alert>
                            </div>
                        </div>
                        <div v-if="addPlayerForm" class="row align-items-center" style="height: 100%;">
                            <div class="col-lg-8">
                                <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading" @click="submitPlayerData">
                                    <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                    <span class="btn-inner--text">Spieler sperren</span></button>
                                <base-button v-if="model.id !== ''" type="danger" icon="fas fa-user-minus" @click="openOrCloseDeleteModal">Spielersperre beenden</base-button>
                            </div>
                        </div>
                    </div>
            <div class="row">
                <div v-if="status.type !== '' && status.type !== 'info'" class="col">
                    <base-button @click="setDefaultData" type="secondary">{{ clearButtonText }}</base-button>
                </div>
            </div>
        </card>
        <modal :show.sync="modals.deleteLock" :showClose="false">
            <h6 slot="header" class="modal-title" id="modal-delete-lock">Sperreintrag löschen</h6>

            <p>Bitte geben Sie den Grund für das Aufheben der Spielersperre an.</p>
            <div v-for="(reason,i) in unlockreasons" :key="i+key+'a'">
                <b-form-checkbox v-model="unlockreason"
                                 ref="aufhebungsgrund"
                                 name="aufhebungsgrund"
                                 style="margin-bottom: 1rem; width: 100%;"
                                 :value="reason.LBEZ"
                                 button-variant="outline-primary"
                                 outline
                                 button>
                    {{reason.LBEZ}} <!--- <b> <i v-if="model.ANLASS.includes(reason)" class="fas fa-check"></i> </b> --->
                </b-form-checkbox></div>


            <template slot="footer">
                <base-button type="link" class="ml-auto" @click="openOrCloseDeleteModal">abbrechen</base-button>
                <base-button type="danger" icon="fas fa-user-minus" @click="runDeleteLock">Spielersperre beenden</base-button>
            </template>
        </modal>
    </div>
</template>
<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import Switches from "vue-switches";

    export default {
        name: 'Spielercheck',
        components: {Switches, flatPickr},
        data() {
            return {
                model: {
                    id: '',
                    passportid: '',
                    firstname: '',
                    lastname: '',
                    bornAt: '',
                    placeofbirth: '',
                    title: '',
                    postcode: '',
                    city: '',
                    streetandnr: '',
                    nationality: '',
                    email: ''
                },
                playerLock: {
                    id: '',
                    player: '',
                    startsAt: '',
                    endsAt: new Date(),
                    type: '',
                    reason: '',
                    comment: ''
                },
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                configDuration: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                status: {
                    type: '',
                    message: '',
                    showBlockedInfo: false
                },
                info: {
                    approve: false,
                    dataprivacy: false
                },
                modals: {
                    deleteLock: false
                },
                unlockreason: '',
                unlockreasons:[
                    {"KBEZ1":"01","LBEZ":"Doppeleintragung","SORTNR":"1"},
                    {"KBEZ1":"02","LBEZ":"Testsperre","SORTNR":"2"},
                    {"KBEZ1":"03","LBEZ":"Vorlage gerichtlicher Beschluss","SORTNR":"3"},
                    {"KBEZ1":"04","LBEZ":"Missbrauch durch Mitarbeiter","SORTNR":"4"},
                    {"KBEZ1":"05","LBEZ":"Sperrantrag durch unberechtigte Person","SORTNR":"5"},
                    {"KBEZ1":"06","LBEZ":"Änderung des Sperrantrags","SORTNR":"6"},
                    {"KBEZ1":"07","LBEZ":"Bedrohung durch Spieler","SORTNR":"7"}
                ],
                isLoading: false,
                playerBlocked: false,
                addPlayerForm: false,
                addPlayerMethod: 'POST',
                addPlayerLockMethod: 'POST',
                blockedMessage: 'Dieser Spieler ist für das Spiel an den Geldspielgeräten gesperrt.',
                notblockedMessage: 'Dieser Spieler hat freien Zugang zu den Geldspielgeräten.',
                errors: [],
                key: 0,
                bornAtField: null
            }
        },
        watch: {
            // eslint-disable-next-line no-unused-vars
            key: function(val, oldVal)  {
                this.$nextTick(() => {
                    this.bornAtField = document.querySelector('input.datepicker.input');
                    this.bornAtField.addEventListener("blur", this.updateOnBlur)
                });
            }
        },
        created() {
            this.setDefaultData();
        },
        mounted() {
            this.bornAtField = document.querySelector('input.datepicker.input');
            this.bornAtField.addEventListener("blur", this.updateOnBlur)
        },
        computed: {
            activeProfile() {
                return this.$store.getters['profiles/showActiveProfile'];
            },
            activeLocation() {
                return this.$store.getters['authentication/location'];
            },
            cardStyle() {
                return this.status.type;
                //return (this.status === 'success') ? (this.playerBlocked) ? 'danger' : 'success' : 'secondary';
            },
            clearButtonText() {
                return (this.status.type !== 'warning' ) ? "fertig" : "zurücksetzen" ;
                    },
            isEmailValid(){
                return (this.model.email === '') ? null : this.validEmail(this.model.email);
            },
            reset(){
                return this.model.firstname !== '' || this.model.lastname !== '' || this.model.bornAt !== '' || this.model.placeofbirth !== ''
            }
        },
        methods: {
            updateOnBlur(e) {
                //this.$refs.pickr.fp.setDate(e.target.value, true, this.config.altFormat);
                this.model.bornAt = this.$options.filters.formatDateFromFormatToFormat('DD.MM.YYYY','YYYY-MM-DD',e.target.value);
            },
            checkPlayer() {
                this.status = {type: '', message: ''};
                if (this.checkSearchValid()){
                    this.isLoading = true;
                    this.getPlayer().then(data => {
                        if (data.totalItems === 1) {
                            this.getBlock(data.member['0']['id']).then(data =>{
                                if (data.totalItems === 1) {
                                    this.playerBlocked = data.member[0]['playerBlocked'];
                                    this.status = {
                                        type: (data.member[0]['playerBlocked']) ? 'danger' : 'success',
                                        message: (data.member[0]['playerBlocked']) ? this.blockedMessage : this.notblockedMessage,
                                        showBlockedInfo: true };
                                } else {
                                    this.playerBlocked = false;
                                    this.status = {type: 'success', message: this.notblockedMessage, showBlockedInfo: true };
                                }
                                this.isLoading = false;
                                // setTimeout(() => { this.setDefaultData(); }, 150000);
                            });
                        } else if (data.totalItems > 1) {
                            this.status = {type: 'warning', message: 'Es wurden mehrere Einträge gefunden. Bitte weitere Felder ausfüllen.', showBlockedInfo: false };
                            this.isLoading = false;
                        } else {
                            this.status = {type: 'success', message: this.notblockedMessage, showBlockedInfo: true };
                            this.playerBlocked = false;
                            this.isLoading = false;
                            //setTimeout(() => { this.setDefaultData(); }, 150000);
                        }


                    }).catch( error => {
                        this.status = {type: 'warning', message: error, showBlockedInfo: false};
                        this.isLoading = false; });
                } else {
                    this.status = {type: 'warning', message: 'Bitte geben Sie zunächst die Vorname, Nachname und Geburtsdatum an.', showBlockedInfo: false};
                }
            },
            getPlayer() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = '/api/players?';

                    let item = this.model;
                    Object.keys(item).forEach(function eachKey(key) {
                            if (item[key] !== '') {
                                if (key === 'bornAt') {
                                    var after = new Date(item[key]);
                                    var before = new Date(item[key]);
                                    before.setDate(before.getDate() + 1);
                                    url = url + key + '[after]' + '=' + after.toISOString() + '&' + key + '[strictly_before]' + '=' + before.toISOString() + '&';
                                } else {
                                    url = url + key + '=' + item[key] + '&';
                                }
                            }
                        }
                    );

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error)});
                })
            },
            getBlock(id){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/player_locks?location=` + this.activeLocation + `&player=` + id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            },
            addPlayer() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.model;
                    delete senddata.id;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/players`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({member: response});},
                            error => { reject(error); });
                });
            },
            editPlayer(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(this.model)
                    };

                    fetch(process.env.VUE_APP_API_SERVER + `/api/players/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({member: response});},
                                    error => { reject(error); });
                        });
            },
            addPlayerLock(playerid) {
                return new Promise((resolve, reject) => {
                    this.playerLock.player = '/api/players/'+playerid;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.playerLock;
                    delete senddata.id;
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/player_locks`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({member: response});},
                            error => { reject(error); });
                });
            },
            editPlayerLock(id) {
                return new Promise((resolve, reject) => {
                    this.playerLock.player = '/api/players/'+this.model.id;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(this.playerLock)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/player_locks/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve({member: response});},
                            error => { reject(error); });
                });
            },
            submitPlayerData(){
                this.status = {type: '', message: ''};
                this.key++;
                if (this.checkSubmitValid()) {
                    this.isLoading = true;
                    // 1. Prüfe ob Spieler bereits existiert, wenn nein Add, sonst Edit
                    if(this.model.id === '') {
                        this.addPlayer().then( data => {
                            this.status = {type: 'success', message: 'Neuer Spieler zur Sperrdatei hinzugefügt.', showBlockedInfo: false };
                            this.setModelData(data.member,'model');
                            this.addPlayerLock(data.member.id).then( data => {
                                    this.status = {type: 'success', message: 'Neuer Spieler zur Sperrdatei hinzugefügt und Sperrdauer für diesen Standort festgelegt.', showBlockedInfo: false};
                                    this.setModelData(data.member,'playerLock');
                                    this.isLoading = false
                                }
                            ).catch(error => {
                                this.status = {type: 'danger', message: error, showBlockedInfo: false};
                                this.isLoading = false;
                            })
                            }
                        ).catch(error => {
                            this.status = {type: 'danger', message: error, showBlockedInfo: false};
                            this.isLoading = false;
                        })
                    } else {
                        this.editPlayer(this.model.id).then( data => {
                                this.status = {type: 'success', message: 'Existierender Spieler in Sperrdatei bearbeitet.', showBlockedInfo: false};
                                this.setModelData(data.member,'model');
                                if(this.playerLock.id === '') {
                                    this.addPlayerLock(data.member.id).then( data => {
                                        this.status = {type: 'success', message: 'Existierender Spieler in Sperrdatei bearbeitet und neue Sperre für diesen Standort hinzugefügt.', showBlockedInfo: false};
                                        this.setModelData(data.member,'playerLock');
                                        this.isLoading = false
                                        }
                                    ).catch(error => {
                                        this.status = {type: 'error', message: error, showBlockedInfo: false};
                                        this.isLoading = false;
                                    })
                                } else {
                                    this.editPlayerLock(this.playerLock.id).then( data => {
                                        this.status = {type: 'success', message: 'Existierender Spieler in Sperrdatei, Sperrdauer und Sperrgrund bearbeitet.', showBlockedInfo: false};
                                        this.setModelData(data.member,'playerLock');
                                        this.isLoading = false;
                                        }
                                    ).catch(error => {
                                        this.status = {type: 'danger', message: error, showBlockedInfo: false};
                                        this.isLoading = false;
                                    })
                                }
                            }
                        ).catch(error => {
                            this.status = {type: 'danger', message: error, showBlockedInfo: false};
                            this.isLoading = false;
                        })
                    }
                    this.isLoading = false;
                } else {
                    this.status = {type: 'warning', message: 'Bitte füllen Sie das Formular vollständig aus. Fehlende Felder wurden gekennzeichnet.'};
                }
            },
            addOrEditPlayer(){
                this.status = {type: '', message: ''};
                if (this.checkSearchValid()) {
                    //if (!this.addPlayerForm || (this.addPlayerForm && this.status.type === 'warning')) {
                        this.isLoading = true;
                        this.getPlayer().then(data => {
                            if (data.totalItems === 1) {
                                this.setModelData(data.member['0'],'model');
                                this.getBlock(data.member['0']['id']).then(data => {
                                    if (data.totalItems === 1) {
                                        this.setModelData(data.member['0'],'playerLock');
                                        this.status = {type: 'info', message: 'Es besteht bereits ein Eintrag zu diesem Spieler. Bitte überprüfen Sie die folgenden Daten auf Vollständig- und Korrektheit.', showBlockedInfo: false};
                                    }
                                    this.isLoading = false;
                                }).catch(error => {
                                    this.status = {type: 'danger', message: error, showBlockedInfo: false};
                                    this.isLoading = false;
                                });
                            } else if (data.totalItems > 1) {
                                this.isLoading = false;
                                this.status = {type: 'warning', message: 'Es wurden mehrere Einträge gefunden. Bitte weitere Felder ausfüllen.', showBlockedInfo: false};
                            } else {
                                this.status = {type: 'info', message: 'Es besteht noch kein Eintrag zu diesem Spieler. Bitte füllen Sie das Formular anhand der Ausweisdaten vollständig und korrekt aus.', showBlockedInfo: false};
                                this.isLoading = false;
                                this.addPlayerMethod = 'POST';
                            }
                        }).catch(error => {
                                this.status = {type: 'danger', message: error, showBlockedInfo: false};
                                this.isLoading = false;
                            }
                        );
                        if (!this.addPlayerForm) this.addPlayerForm = !this.addPlayerForm;
                    //}
                } else {
                    this.status = {type: 'warning', message: 'Bitte geben Sie zunächst Vorname, Nachname und Geburtsdatum an.', showBlockedInfo: false};
                }
            },
            openOrCloseDeleteModal() {
                this.modals.deleteLock = !this.modals.deleteLock;
                this.key++;
            },
            setModelData(data, type) {
                let item = (type === 'model') ? this.model : this.playerLock;
                let out = {};
                Object.keys(item).forEach(function eachKey(key) {
                    out[key] = data[key];
                    }
                );
                if (type === 'model') {
                    this.model = out;
                } else {
                    this.playerLock = out;
                }
            },
            checkSearchValid() {
                if (this.model.firstname !== '' && this.model.lastname !== '' && this.model.bornAt !== '') {
                    return true;
                }

                this.errors = [];

                if (!this.model.firstname) {
                    this.errors.push('firstname');
                }
                if (!this.model.lastname) {
                    this.errors.push('lastname');
                }
                if (!this.model.bornAt) {
                    this.errors.push('bornAt');
                }
                this.key++;

                return false;
            },
            checkSubmitValid() {
                if (this.model.firstname !== ''
                    && this.model.lastname !== ''
                    && this.model.bornAt !== ''
                    && this.model.placeofbirth !== ''
                    && this.model.postcode !== ''
                    && this.model.city !== ''
                    && this.model.streetandnr !== ''
                    && this.model.nationality !== ''
                    && this.playerLock.reason !== ''
                    && this.playerLock.type !== ''
                    && this.info.approve === true
                    && this.info.dataprivacy === true) {
                    return true;
                }

                this.errors = [];

                if (!this.model.firstname) { this.errors.push('firstname'); }
                if (!this.model.lastname) { this.errors.push('lastname'); }
                if (!this.model.bornAt) { this.errors.push('bornAt'); }
                if (!this.model.placeofbirth) { this.errors.push('placeofbirth'); }
                if (!this.model.postcode) { this.errors.push('postcode'); }
                if (!this.model.city) { this.errors.push('city'); }
                if (!this.model.streetandnr) { this.errors.push('streetandnr'); }
                if (!this.model.nationality) { this.errors.push('nationality'); }
                if (!this.playerLock.reason) { this.errors.push('reason'); }
                if (!this.playerLock.type) { this.errors.push('type'); }
                if (this.info.approve === false) { this.errors.push('APPROVE'); }
                if (this.info.dataprivacy === false) { this.errors.push('PRIVACY'); }

                this.key++;

                return false;
            },
            runDeleteLock() {
                this.isLoading = true;
                this.openOrCloseDeleteModal();
                let d2 = new Date();
                let year2 = d2.getFullYear();
                let month2 = d2.getMonth();
                let day2 = d2.getDate();
                let c3 = new Date(year2, month2, day2 - 1);
                this.playerLock.endsAt = c3;
                this.playerLock.comment = this.playerLock.comment+"\n"+"Sperre aufgrund '"+this.unlockreason+"' am "+this.$options.filters.formatDate(d2)+" aufgehoben.";
                this.editPlayerLock(this.playerLock.id).then( data => {
                        this.status = {type: 'success', message: 'Spielersperre aufgehoben.', showBlockedInfo: false};
                        this.setModelData(data.member,'playerLock');
                        this.isLoading = false;

                    }
                ).catch(error => {
                    this.status = {type: 'danger', message: error, showBlockedInfo: false};
                    this.isLoading = false;
                });
                this.key++;
            },
            locationData() {
                return this.$store.getters['location/showLocationByIRI']('/api/locations/'+this.$store.getters['authentication/location']);
            },
            isDemo() {
              return process.env.VUE_APP_DEMOUSER === this.$store.getters['authentication/email']
            },
            setDefaultData() {
                var d = new Date();
                var year = d.getFullYear();
                var month = d.getMonth();
                var day = d.getDate();
                var c = new Date(year + 1, month, day);
                this.model = {
                        id: '',
                        passportid: '',
                        firstname: '',
                        lastname: '',
                        bornAt: '',
                        placeofbirth: '',
                        title: '',
                        postcode: '',
                        city: '',
                        streetandnr: '',
                        nationality: '',
                        email: ''
                };
                this.playerLock= {
                        id: '',
                        type: '',
                        player: '',
                        startsAt: new Date(),
                        endsAt: c,
                        reason: '',
                        comment: ''
                };

                var d2 = new Date();
                var year2 = d2.getFullYear();
                var month2 = d2.getMonth();
                var day2 = d2.getDate();
                var c2 = new Date(year2 - this.locationData().minAge, month2, day2);
                this.config.maxDate = c2;


                this.isLoading= false;
                this.status = {type: '', message: '', showBlockedInfo: false};
                this.playerBlocked= false;
                this.addPlayerForm=false;
                this.errors = [];
                this.key++;
            }
        }
    }
</script>
<style>
    .ausweis {
        height: 200px;
        background-image: url('/img/ausweis.png');
        background-repeat: no-repeat;
        background-position: right;
        background-size: auto 100%;
    }


    .is-invalid {
        box-shadow: 0 1px 3px rgba(255, 27, 39, 0.6), 0 1px 0 rgba(0, 0, 0, 0.05);
        color: rgba(255, 27, 39, 0.6);
    }

    .is-invalid-select {
        color: rgba(255, 27, 39, 0.6);
        border-color: rgba(255, 27, 39, 0.6);
    }

    .hero-alert {
      margin: 2rem 0;
    }

    .hero-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      padding: 0.5rem;
    }

    .hero-text {
      font-size: 1.1rem;
      color: white;
    }

    .highlight-text {
      font-weight: bold;
      position: relative;
      background: linear-gradient(104deg, rgba(255,255,255,0) 0.9%, rgba(255,255,255,0.3) 2.4%, rgba(255,255,255,0.1) 5.8%, rgba(255,255,255,0.1) 93%, rgba(255,255,255,0.1) 96%, rgba(255,255,255,0) 98%);
      padding: 0 0.5rem;
      margin: 0 0.5rem;
    }

    .cta-button {
      background: white;
      color: #dc3545;
      padding: 0.5rem 1rem;
      border-radius: 4px;
      text-decoration: none;
      font-weight: bold;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .cta-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .arrow {
      transition: transform 0.3s ease;
    }

    .cta-button:hover .arrow {
      transform: translateX(4px);
    }

    .animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.85;
      }
    }
</style>